import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { RootState } from '../store';

const BASE_API = process.env.REACT_APP_BASE_API;

interface IAnyResponse {
  [key: string]: any;
}

interface IGetCrewPayload {
  crewId: string | number | undefined;
  lang: string;
}

interface IGetPromotedCrewsPayload {
  lang: string;
}

interface IGetAmbassadorCrewPayload {
  lang: string;
  username: string;
}

export const crewSlice = createApi({
  reducerPath: 'crew',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_API,
    prepareHeaders: (headers, { getState, endpoint }) => {
      const token = (getState() as RootState).isAuth.isAuth;
      const lang = (getState() as RootState).language.lang;
      const publicEndpoints = ['getCrew', 'getPromotedCrews'];
      const isPublic = publicEndpoints.includes(endpoint);
      if (token && !isPublic) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      headers.set('Accept-Language', lang);
      return headers;
    }
  }),
  tagTypes: ['Crew'],
  endpoints: (builder) => ({
    getCrew: builder.query<IAnyResponse, IGetCrewPayload>({
      query: (payload) => ({
        url: `/crew/${payload.crewId}`,
        method: 'GET'
      })
    }),

    getPromotedCrews: builder.query<IAnyResponse, IGetPromotedCrewsPayload>({
      query: (payload) => ({
        url: `/crews-promoted`,
        method: 'GET'
      })
    }),

    getAmbassadorCrew: builder.query<IAnyResponse, IGetAmbassadorCrewPayload>({
      query: (payload) => ({
        url: `/crew-ambassador/`,
        method: 'GET'
      })
    })
  })
});

export const { useGetCrewQuery, useGetPromotedCrewsQuery, useGetAmbassadorCrewQuery } = crewSlice;
